export const minAmountTransfer = 50000000;
export const maxAmountTransfer = 100000000;
export const minTransferSaman = 1000;
export const maxTransferSaman = 200000000;
